import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../../lib/auth.js';

function Protected({ children }) {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

export default Protected;
